import React from 'react';
import { Box, Typography, Container, List, ListItem, ListItemText } from '@mui/material';

function ExclusiveArtist() {
    return (
        <Container maxWidth="md">
            <Box sx={{ padding: '20px' }}>
                <Typography variant="h5" gutterBottom>
                    FM Digital Official Exclusive Artist Agreement
                </Typography>
                <Typography variant="body1" gutterBottom>
                    This Exclusive Artist Agreement ("Agreement") is entered into by and between FM Digital Official, having its office at Uttar Pradesh, India, acting through its Managing Director, Mr. Ashish Rajput ("Company"), and the undersigned artist ("Artist"). This Agreement sets forth the terms and conditions of the Artist’s exclusive relationship with the Company for distribution and management services.
                </Typography>

                <Typography variant="h6" gutterBottom>
                    1. Exclusivity
                </Typography>
                <Typography variant="body1" gutterBottom>
                    The Artist agrees to grant FM Digital Official exclusive rights to distribute, promote, and manage all of the Artist’s music, including but not limited to streaming, digital sales, radio airplay, and synchronization opportunities (TV, movies, etc.). During the term of this Agreement, the Artist shall not engage any other entity for distribution, management, or promotion without the prior written consent of the Company.
                </Typography>

                <Typography variant="h6" gutterBottom>
                    2. Term of Agreement
                </Typography>
                <Typography variant="body1" gutterBottom>
                    This Agreement shall be valid for a period of two (2) years from the date of signing by the Artist. The Agreement will not automatically renew.
                </Typography>

                <Typography variant="h6" gutterBottom>
                    3. Services Offered
                </Typography>
                <Typography variant="body1" gutterBottom>
                    The Artist shall have access to all services provided by FM Digital Official at no additional cost during the two (2) year period, including but not limited to:
                </Typography>
                <List>
                    <ListItem>
                        <ListItemText primary="Music distribution" />
                    </ListItem>
                    <ListItem>
                        <ListItemText primary="Playlist pitching" />
                    </ListItem>
                    <ListItem>
                        <ListItemText primary="Synchronization pitching" />
                    </ListItem>
                    <ListItem>
                        <ListItemText primary="Radio campaigns" />
                    </ListItem>
                    <ListItem>
                        <ListItemText primary="Marketing and promotion" />
                    </ListItem>
                    <ListItem>
                        <ListItemText primary="Stage performance shows" />
                    </ListItem>
                    <ListItem>
                        <ListItemText primary="Event singing" />
                    </ListItem>
                </List>

                <Typography variant="h6" gutterBottom>
                    4. Copyright Ownership
                </Typography>
                <Typography variant="body1" gutterBottom>
                    All songs created specifically for the label during the term of this Agreement shall be the exclusive property of FM Digital Official. The Company shall hold full copyright ownership of these works.
                </Typography>

                <Typography variant="h6" gutterBottom>
                    5. Revenue Sharing
                </Typography>
                <Typography variant="body1" gutterBottom>
                    The Artist agrees to the following revenue sharing structure:
                </Typography>
                <List>
                    <ListItem>
                        <ListItemText primary="70% of royalties for all events and stage shows organized by FM Digital Official during the Agreement period." />
                    </ListItem>
                    <ListItem>
                        <ListItemText primary="40% of royalties from digital distribution of songs made for the label after the Agreement's expiration." />
                    </ListItem>
                </List>

                <Typography variant="h6" gutterBottom>
                    6. Intellectual Property Rights
                </Typography>
                <Typography variant="body1" gutterBottom>
                    FM Digital Official shall be the primary copyright owner of all songs produced under this Agreement. The Artist shall act solely as a performer and shall receive 70% of the royalties from all events or stage shows they perform in as part of the Company’s services.
                </Typography>

                <Typography variant="h6" gutterBottom>
                    7. Rights of Assignment
                </Typography>
                <Typography variant="body1" gutterBottom>
                    FM Digital Official reserves the right to assign or transfer this Agreement to any parent, subsidiary, or affiliate entity, or to any party acquiring substantially all of its assets, provided that the terms and conditions of the Agreement remain unchanged.
                </Typography>

                <Typography variant="h6" gutterBottom>
                    8. Payment Schedule
                </Typography>
                <Typography variant="body1" gutterBottom>
                    FM Digital Official shall provide monthly financial reports to the Artist, detailing revenue earned from music distribution, licensing, and other related activities. Payments to the Artist will be made within thirty (30) days following the end of each reporting period.
                </Typography>

                <Typography variant="h6" gutterBottom>
                    9. Dispute Resolution
                </Typography>
                <Typography variant="body1" gutterBottom>
                    Any disputes arising from this Agreement shall be resolved through good faith negotiations between the parties. If the dispute cannot be resolved through negotiations, it shall be submitted to binding arbitration in accordance with the laws of India.
                </Typography>

                <Typography variant="h6" gutterBottom>
                    10. Governing Law
                </Typography>
                <Typography variant="body1" gutterBottom>
                    This Agreement shall be governed by and construed in accordance with the laws of India, without regard to its conflict of law principles.
                </Typography>

                <Typography variant="h6" gutterBottom>
                    11. Agreement Renewal
                </Typography>
                <Typography variant="body1">
                    This Agreement will not be renewed automatically. The Artist must provide written notice if they wish to continue working with FM Digital Official beyond the initial two (2) year term.
                </Typography>
            </Box>
        </Container>
    );
}

export default ExclusiveArtist;
